import React, { useState, useEffect, useRef } from 'react';
import { 
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Label,
  CustomInput,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import ClientTable from './DesistementClientTable';
import EncaissementTable from './DesistementEncaissementTable';
import DesistementAddedClientTable from './DesistementAddedClientTable';
import ClientAdd from '../client/ClientAdd';
import VEncaissementContainer from '../vente/encaissement/VEncaissementContainer';
import VenteListTable from './DesistementVenteListTable';
import VBienTable from '../vente/bien/VBienTable';
import VBienCard from '../vente/bien/VBienCard';
import Association from '../consultation/Association';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges'
import { connect } from 'react-redux';
import { getVenteByIdPromise, getVentesByNumDossier, getVenteIDFromID, getVenteIDFromBienID, getVentesByCIN, getVentesByEnc } from '../../flux/actions/venteActions';
import { searchClients } from '../../flux/actions/clientActions';
import { getBiensPromise } from '../../flux/actions/bienActions';
import { IClient, IDesistementPanel, IDesistementPanelReduxProps, ITableClientLine, ITarget } from '../../types/interfaces';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faSearch, faBookmark, faMapMarkerAlt, faSignature, faFolder, faFileInvoice, faReceipt, faFileContract, faFilePdf, faSync, faCloudUploadAlt, faHandRock, faTimes, faSpinner, faCheckCircle, faInfoCircle, faPercent, faExternalLinkAlt, faPlus, faHome, faCalendarAlt, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import moment from "moment";
import PDFLink from '../pdf/PDFLink';

const DesistementPanelComponent = ({ 
  panelNumber,
  panelTitle,
  selectVente,
  venteLoading,
  setVenteLoading,
  consultationState,
  setConsultationState,
  selectedVente,
  setSelectedVente,
  isAssociation,
  clientsTableData,
  setClientsTableData,
  encaissementsTableData,
  setEncaissementsTableData,
  theOtherPanelClientsTransfers,
  theOtherPanelEncaissementsTransfers,
  tableAddedClientsLines,
  setTableAddedClientsLines,
  asyncSelectKey,
  setAsyncSelectKey,
  duplicateClient,
  setDuplicateClient,
  totalWithdraw,
  setTotalWithdraw,
  transferToNew,
  setTransferToNew,
  changeBien,
  setChangeBien,
  selectedBien,
  setSelectedBien,
  selectedAssociation,
  setSelectedAssociation,
  isAssociationBien,
  setIsAssociationBien,
  enableDesistement,
  enableTransfert,
  enableChangementBien,
  auth
 }: IDesistementPanel) => {
  const alert = useAlert();
  const history = useHistory();

  const [activeTab, setActiveTab] = useState(constants.TAB_BIEN);
  const selectSocieteOptions = auth?.user?.societes?.sort((a, b) => (!a.LIBELE && !b.LIBELE) ? 0 : !a.LIBELE ? -1 : !b.LIBELE ? 1 : a.LIBELE.localeCompare(b.LIBELE)).map(e => ({value: e, label: e.LIBELE})) || [];
  const [societeValue, setSocieteValue] = useState<any>('');
  const [societeBiensValue, setSocieteBiensValue] = useState<any>('');
  const selectOptions = [{value: constants.CONSULTATION_SELECT_N_DOSSIER, label: "N° Dossier"}/*, {value: constants.CONSULTATION_SELECT_ID_CONTRAT, label: "ID Vente Sys"}, {value: constants.CONSULTATION_SELECT_ID_BIEN, label: "ID Bien Sys"}*/, {value: constants.CONSULTATION_SELECT_CIN, label: "CIN"}, {value: constants.CONSULTATION_SELECT_REF_REG, label: "Réf. Encaissement"}];
  const [selectedValue, setSelectedValue] = useState(selectOptions[0]);
  const [searchValue, setSearch] = useState('');
  // const { info, loading } = vente;
  // const [venteLoading, setVenteLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [modal, setModal] = useState(false);
  // const [consultationState, setConsultationState] = useState(1);
  const [ventesList, setVentesList] = useState<any[]>([]);
  const [consultationTableLoading, setConsultationTableLoading] = useState(false);
  const [getDataFromPromise, setGetDataFromPromise] = useState(false);
  const searchRef = useRef<HTMLInputElement>(document.createElement("input"));
  
  const [associationPartInfo, setAssociationPartInfo] = useState<any>('');

  const [selectedClient, setSelectedClient] = useState('');
  const [lineCountValue, setLineCount] = useState(0);
  const [modalClient, setModalClient] = useState(false);

  // const [totalWithdraw, setTotalWithdraw] = useState(false);
  // const [changeBien, setChangeBien] = useState(false);
  const [biens, setBiens] = useState<any[]>([]);
  const [biensLoading, setBiensLoading] = useState(false);
  // const [selectedBien, setSelectedBien] = useState<any>(null);
  const [remiseValue, setRemiseValue] = useState(0);
  const [remiseTotalValue, setRemiseTotalValue] = useState(true);
  const [prixAafficherValue, setPrixAafficherValue] = useState(0);
  const [prixAafficherTotalValue, setPrixAafficherTotalValue] = useState(false);
  // const [selectedAssociation, setSelectedAssociation] = useState(undefined);
  // const [isAssociationBien, setIsAssociationBien] = useState(false);
  // const [disableAssociation, setDisableAssociation] = useState(false);

  const handleToggleClient = () => setModalClient(!modalClient);

  useEffect(() => console.log("selectedVente", selectedVente), [selectedVente]);//TODO remove this later
  
  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
    searchRef.current.focus();
  }
  const handleSelectChange = data => {
    setSelectedValue(data || '');
    searchRef.current.focus();
  }

  const handleSocieteBiensChange = data => {
    setSocieteBiensValue(data ? data.value : '');
  }

  useEffect(() => {
    if(auth?.user?.societes?.length){
      if(selectedVente?.PROJET){
        for(let e of auth.user.societes)
          if(e.LIBELE == selectedVente.PROJET){
            setSocieteValue(e);
            setSocieteBiensValue(e);
            break
          }
      }
      else if(!selectedVente?.bien){
        for(let e of auth.user.societes)
          if(e.id == auth.user.last_societe){
            setSocieteValue(e);
            setSocieteBiensValue(e);
            break
          }
      }
    }
  }, [selectedVente?.PROJET, auth?.user?.societes]);

  useEffect(() => {
    if(totalWithdraw){
      setChangeBien(false)
      setTransferToNew(false)
    }
    // if(totalWithdraw && (((clientsTableData?.filter(e => !!e.transfere || !!e.desiste).length || 0) !== ((selectedVente?.associationPart || selectedVente)?.contrat_clients?.length || 0)) || ((encaissementsTableData?.filter(e => !!e.transfere || !!e.desiste).length || 0) !== ((selectedVente?.associationPart || selectedVente)?.contrat_encaissements?.length || 0))))
    //   alert.info("Veuillez vider les clients/encaissements")
    if(enableDesistement){
      setClientsTableData(e => e.map(e => ({...e, desiste_p: false, desiste: !!totalWithdraw})));
      setEncaissementsTableData(e => e.map(e => ({...e, desiste: !!totalWithdraw})));
    }
  }, [totalWithdraw])

  useEffect(() => {
    if(changeBien){
      setTotalWithdraw(false)
      setTransferToNew(false)
    }
  }, [changeBien])

  useEffect(() => {
    if(transferToNew){
      setTotalWithdraw(false)
      setChangeBien(false)
    }
  }, [transferToNew])

  const searchChangeHandler = (e: ITarget) => setSearch(e.target.value);
  const onSearchFocus = (e) => {
    e.target.select();
  };

  const handleSearchKeyDown = (event) => {
    if(event.key === 'Enter')
      search()
  }

  useEffect(() => {
    switch(selectedVente?.bien?.TYPE_2?.toLowerCase()){
      case constants.LOT: setImageUrl("url('/images/soil.png')"); break;
      case constants.VILLA: setImageUrl("url('/images/villa.png')"); break;
      case constants.APPARTEMENT: setImageUrl("url('/images/apartment.png')"); break;
      case constants.MAGASIN: setImageUrl("url('/images/shop.png')"); break;
      case constants.EQUIPEMENT: setImageUrl("url('/images/equipment.png')"); break;
      default: setImageUrl(""); break;
    }
  }, [selectedVente])

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  useEffect(() => {
    setClientsTableData((selectedVente ? selectedVente.associationPart ? selectedVente?.associationPart?.contrat_clients : selectedVente.contrat_clients : []).map(e => ({transfere: false, desiste: false, desiste_p: false, ...e})));
    // setClientsTableData((selectedVente?.contrat_clients?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || []).map(e => ({transfere: false, desiste: false, ...e})));
  }, [selectedVente?.contrat_clients, selectedVente?.associationPart?.contrat_clients]);

  useEffect(() => {
    setEncaissementsTableData((selectedVente ? selectedVente.associationPart ? selectedVente?.associationPart?.contrat_encaissements : selectedVente.contrat_encaissements : []).map(e => ({transfere: false, desiste: false, ...e})));
  }, [selectedVente?.contrat_encaissements, selectedVente?.associationPart?.contrat_encaissements]);

  const search = async () => {
    if(!selectedValue || searchValue === '')
      return
    if(!societeValue){
      alert.info("Veuillez sélectionner un projet");
      return
    }

    setConsultationTableLoading(true);
    let returnedArray: any[] = [];
    const re = /^[0-9\b]+$/;

    if(selectedValue.value === constants.CONSULTATION_SELECT_N_DOSSIER){
      setConsultationState(2);
      const resVentesList = await getVentesByNumDossier(searchValue, societeValue["id"], /*auth?.user.societes?.map(e => e.LIBELE) || [], !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
      if(resVentesList?.length)
        returnedArray = resVentesList
    }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_ID_CONTRAT){
      if(re.test(searchValue.toString()) && +searchValue >= 0){
        setConsultationState(1);
        const resVenteID = await getVenteIDFromID(+searchValue, societeValue["id"]);
        if(resVenteID && typeof resVenteID === 'number'){
          setConsultationState(1);
          const resVente = await getVenteByIdPromise(resVenteID);
          setSelectedVente(resVente || undefined)
        }
        else{
          alert.info("Aucun résultat trouvé")
          setSelectedVente(undefined)
        }
      }
    }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_ID_BIEN){
      if(re.test(searchValue.toString()) && +searchValue >= 0){
        setConsultationState(1);
        const resVenteID = await getVenteIDFromBienID(+searchValue, societeValue["id"]);
        if(resVenteID && typeof resVenteID === 'number'){
          setConsultationState(1);
          const resVente = await getVenteByIdPromise(resVenteID);
          setSelectedVente(resVente || undefined)
        }
        else{
          alert.info("Aucun résultat trouvé")
          setSelectedVente(undefined)
        }
      }
    }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_CIN){
      setConsultationState(2);
      const resVentesList = await getVentesByCIN(searchValue, societeValue["id"]/*, auth?.user.societes?.map(e => e.LIBELE) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
      if(resVentesList?.length)
        returnedArray = resVentesList
    }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_REF_REG){
      setConsultationState(2);
      const resVentesList = await getVentesByEnc(searchValue, societeValue["id"]/*, auth?.user.societes?.map(e => e.LIBELE) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
      if(resVentesList?.length)
        returnedArray = resVentesList
    }

    setGetDataFromPromise([constants.CONSULTATION_SELECT_CIN, constants.CONSULTATION_SELECT_REF_REG].includes(selectedValue.value));

    setConsultationTableLoading(false);
    setVentesList(returnedArray);
  }

  // const selectVente = e => {
  //   setConsultationState(1);
  //   setVenteLoading(true);
  //   getVenteByIdPromise(e).then(res => {
  //     setSelectedVente(res || undefined);
  //     setVenteLoading(false);
  //   });
  // }

  const modalClosedHandle = () => {
    setVentesList([]);
  };
  
  const promiseOptions = inputValue =>
    new Promise(resolve => {
      searchClients(inputValue).then(e => 
        resolve(e.map(t => ({label: `${t.NOM} ${t.PRENOM}`, value: t})))
      ).catch(err => resolve([]));
    });

  const handleClientSelectChange = data => {
    if(data?.value && !tableAddedClientsLines.map(e => e.id).includes(data.value.id)){
      setTableAddedClientsLines(e => [...e, {...data.value, lineIndex: lineCountValue}]);
      setLineCount(e => e + 1);
    }
    setSelectedClient('');
  }

  const deleteTableClientC = (lineIndex: number) => {
    setTableAddedClientsLines(e => e.filter(t => t.lineIndex !== lineIndex));
  };

  const addTableClientCallback = (client: IClient) => {
    setTableAddedClientsLines(e => [...e, {...client, lineIndex: lineCountValue}]);
    setLineCount(e => e + 1);
    setAsyncSelectKey(e => e + 1)
  };

  useEffect(() => {
    if(changeBien || transferToNew){
      setBiens([]);
      if(societeBiensValue?.LIBELE){
        setBiensLoading(true);
        getBiensPromise(societeBiensValue.id, societeBiensValue.LIBELE, isAssociationBien ? 1 : 0).then(res => {
          if(res?.length)
            setBiens(res)
          setBiensLoading(false);
        })
      }
    }
  }, [societeBiensValue, isAssociationBien, changeBien, transferToNew])

  const changeIsAssociationBienHandle = (e) => {
    setIsAssociationBien(e.target.checked);
    // setDisableAssociation(true);
    // setTimeout(() => setDisableAssociation(false), 1000);
  };

  return (
    <Container className="desistementPanel">
      <div>
        <Row className="justify-content-between" style={{marginBottom: "20px"}}>
          <Col xs="12" md="5" style={{display: "flex", alignItems: "center"}}><h2 className="title" style={{marginBottom: 0}}>{panelTitle}</h2></Col>
          <Col xs="12" md="3" className="mb-2 mb-md-0">
              <Select
                id="societes"
                className="reactselect"
                classNamePrefix="react-select"
                value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Sélectionner un projet...'}
                isClearable={false}
                // isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                options={selectSocieteOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
          </Col>
          <Col xs="12" md="2" className="mb-2 mb-md-0">
              <Select
                name="searchSelect"
                className="reactselect"
                classNamePrefix="react-select"
                defaultValue={selectOptions[0]}
                value={selectedValue}
                // value={{value: societeValue.value, label: societeValue.label}}
                onChange={handleSelectChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={false}
                options={selectOptions}                
              />
          </Col>
          <Col xs="12" md="2" style={{display: "flex"}}>
            <Input style={{display: "inline-flex", flex: 1, marginRight: "10px"}} placeholder="N°..." innerRef={searchRef} value={searchValue} onChange={searchChangeHandler} onKeyDown={handleSearchKeyDown} onFocus={onSearchFocus} />
            <Button className="btnA"
              onClick={search}>
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </Col>
        </Row>
      </div>
      {consultationState === 2 ? consultationTableLoading ? <Loading /> : <VenteListTable ventesData={ventesList} selectVente={selectVente} getDataFromPromise={getDataFromPromise} /> : <div className="fadeAnimation"><div className="venteContainer">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === constants.TAB_BIEN ? "active" : ""}
              onClick={() => { toggle(constants.TAB_BIEN); }} >
              Bien Vendu
            </NavLink>
          </NavItem>
          {/* {selectedVente?.TYPE_VENTE === "ASSOCIATION" ? <NavItem>
            <NavLink
              className={activeTab === constants.TAB_ASSOCIATION ? "active" : ""}
              onClick={() => { toggle(constants.TAB_ASSOCIATION); }} >
              Association
            </NavLink>
          </NavItem> : null} */}
          <NavItem>
            <NavLink
              className={activeTab === constants.TAB_CLIENT ? "active" : ""}
              onClick={() => { toggle(constants.TAB_CLIENT); }} >
              Clients ({(selectedVente?.associationPart || selectedVente)?.contrat_clients?.map(e => e.client).map(e => e?.id).filter((value, index, self) => value === undefined || self.indexOf(value) === index).length || 0})
              {selectedVente && theOtherPanelClientsTransfers?.length ? <div style={{display: "inline-block", color: "blue"}}>&nbsp;(+{theOtherPanelClientsTransfers.length})</div> : null}
              {selectedVente && clientsTableData?.filter(e => !!e.transfere || !!e.desiste).length ? <div style={{display: "inline-block", color: "red"}}>&nbsp;(-{clientsTableData.filter(e => !!e.transfere || !!e.desiste).length})</div> : null}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === constants.TAB_ENCAISSEMENT ? "active" : ""}
              onClick={() => { toggle(constants.TAB_ENCAISSEMENT); }} >
              Encaissements ({(selectedVente?.associationPart || selectedVente)?.contrat_encaissements?.length || 0})
              {selectedVente && theOtherPanelEncaissementsTransfers?.length ? <div style={{display: "inline-block", color: "blue"}}>
                &nbsp;(+{theOtherPanelEncaissementsTransfers.length})
                <FontAwesomeIcon icon={faInfoCircle} style={{cursor: "pointer"}} data-tip data-for={`addedEncaissementstooltip_${panelNumber}`} />
                <ReactTooltip effect="solid" id={`addedEncaissementstooltip_${panelNumber}`} type={"dark"}>
                  {theOtherPanelEncaissementsTransfers.map(e => "+" + (e.PART || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh").join(", ")}
                </ReactTooltip>
              </div> : null}
              {selectedVente && encaissementsTableData?.filter(e => !!e.transfere || !!e.desiste).length ? <div style={{display: "inline-block", color: "red"}}>
                &nbsp;(-{encaissementsTableData.filter(e => !!e.transfere || !!e.desiste).length})
                <FontAwesomeIcon icon={faInfoCircle} style={{cursor: "pointer"}} data-tip data-for={`subtractedEncaissementstooltip_${panelNumber}`} />
                <ReactTooltip effect="solid" id={`subtractedEncaissementstooltip_${panelNumber}`} type={"dark"}>
                  {encaissementsTableData.filter(e => !!e.transfere || !!e.desiste).map(e => "-" + (e.PART || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh").join(", ")}
                </ReactTooltip>
              </div> : null}
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={constants.TAB_BIEN}>
            {/* <div className=""> */}
              {venteLoading ? <Loading topSpace /> : selectedVente?.bien ? <Container className="CardInfo fadeAnimation" style={{marginBottom: "8px"}}>
                <Row className="padding-0">
                  <Col xs="12" md="3" className="cardImageContainer">
                    <div title={selectedVente.bien?.TYPE_2 || ""} className="cardImage" style={{backgroundImage: imageUrl}}></div>
                    <div className="cardImageTitle">{selectedVente.TYPE || '-'}</div>
                  </Col>
                  <Col xs="12" md="9" style={{border: "none"}}>
                    <Row className="justify-content-end" style={{padding: 0}}>
                      <PDFLink documentType={"vente"}
                        data={selectedVente}
                        download={false}
                        buttonContent=" Fiche de vente"
                        customClassNames="desistementTopBtns"
                        // customClassNames="btn btn-success linesConfirmationBtn linesDeleteBtn pl-3 pr-3 mb-2"
                        customButtonIcon={faFileInvoice}
                        iconSize="inherit"
                        allowPrintPreview={true} />
                      <button className="desistementTopBtns" title={`Ouvrir la consulation ID ${selectedVente.id}`} onClick={() => window.open('/consultation/' + selectedVente.id, '_blank')}>
                        <FontAwesomeIcon icon={faExternalLinkAlt} />&nbsp;Plus de détails
                      </button>
                    </Row>
                    <Row>
                      {/* <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faSignature} />&nbsp;<strong>ID Bien : </strong>{selectedVente.ID_BIEN}
                      </Col> */}
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faFolder} />&nbsp;<strong>Dossier N° : </strong>{selectedVente.NUM_DOSS}
                      </Col>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faCalendarAlt} />&nbsp;<strong>Date de vente : </strong>{selectedVente.DATE_RESERV ? moment(selectedVente.DATE_RESERV).format('DD/MM/YYYY') : "-"}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />&nbsp;<strong>Projet : </strong>{selectedVente.PROJET || '-'}
                        {/* <FontAwesomeIcon icon={faHouseDamage} />&nbsp;<strong>Type : </strong>{selectedVente.TYPE || '-'} */}
                      </Col>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faHashtag} />&nbsp;<strong>N° : </strong>{selectedVente.N}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faThLarge} />&nbsp;<strong>Tranche : </strong>{selectedVente.TRANCHE || "-"}
                      </Col>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faBuilding} />&nbsp;<strong>Immeuble : </strong>{!selectedVente.IMMEUBLE && selectedVente.IMMEUBLE !== "0" ? "-" : selectedVente.IMMEUBLE}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faLayerGroup} />&nbsp;<strong>Étage N° : </strong>{!selectedVente.ETAGE && selectedVente.ETAGE !== "0" ? "-" : selectedVente.ETAGE}
                      </Col>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedVente.TYPE_2?.toLowerCase() === "appartement" ? "-" : (selectedVente.SUPERFICIE + "m²")}
                      </Col>
                    </Row>
                    {(selectedVente.ORIENTATION || selectedVente.POSITION) && <Row>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faCompass} />&nbsp;<strong>Orientation : </strong>{selectedVente.ORIENTATION || "-"}
                      </Col>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faMap} />&nbsp;<strong>Position : </strong>{selectedVente.POSITION || "-"}
                      </Col>
                    </Row>}
                    {selectedVente.REMISE || selectedVente.PRIX_M_CLIENT ? <Row>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faPercent} />&nbsp;<strong>Remise : </strong>{(selectedVente.REMISE !== null && selectedVente.REMISE !== undefined) ? (<div style={{display: "inline-block", ...(selectedVente.REMISE > 0 ? selectedVente.REMISE_VALIDEE === -1 ? {color: "orangered"} : selectedVente.REMISE_VALIDEE === 0 ? {color: "red"} : {} : {})}}>
                          {selectedVente.REMISE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}&nbsp;Dh{selectedVente.REMISE > 0 ? " (du total)" : ""}&nbsp;
                          {selectedVente.REMISE > 0 && (selectedVente.REMISE_VALIDEE === -1 || selectedVente.REMISE_VALIDEE === 0) ? <div style={{display: "inline-block"}}>
                            <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="remise_tooltip" />
                            <ReactTooltip effect="solid" id="remise_tooltip" type={"dark"}>
                              {selectedVente.REMISE_VALIDEE === -1 ? "Demande de remise pas encore validée par l'administration" : selectedVente.REMISE_VALIDEE === 0 ? "Demande de remise refusée par l'administration" : ""}
                            </ReactTooltip>
                          </div> : null}
                        </div>) : "-"}
                      </Col>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix comm. Client : </strong>{(selectedVente.PRIX_M_CLIENT !== null && selectedVente.PRIX_M_CLIENT !== undefined) ? (selectedVente.PRIX_M_CLIENT.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh (du total)") : "-"}
                      </Col>
                    </Row> : null}
                    <Row>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faMoneyBillAlt} />&nbsp;<strong>Prix Net du M² : </strong>{(selectedVente.PRIX_M !== null && selectedVente.PRIX_M !== undefined) ? (selectedVente.PRIX_M.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
                      </Col>
                      <Col xs="12" sm="6">
                        <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix Net : </strong>{(selectedVente.PRIX_NET !== null && selectedVente.PRIX_NET !== undefined) ? (selectedVente.PRIX_NET.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
                      </Col>
                    </Row>
                    <Row style={{color: "purple"}}>
                      <Col xs="12" sm="6">
                        <strong>ID Contrat : </strong> {selectedVente.id}
                      </Col>
                      <Col xs="12" sm="6">
                        <strong>ID Bien : </strong> {selectedVente.bien?.id}
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {selectedVente.associationPart ? <Row>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faSignature} />&nbsp;<strong>ID : </strong>{selectedVente.associationPart.id}
                  </Col>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faLayerGroup} />&nbsp;<strong>Étage : </strong>{selectedVente.associationPart.ETAGE === "0" ? "RDC" : (selectedVente.associationPart.ETAGE || "-")}
                  </Col>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faPercent} />&nbsp;<strong>Part : </strong>{selectedVente.associationPart.POURCENTAGE || "-"}%
                  </Col>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faHome} />&nbsp;<strong>Type : </strong>{selectedVente.associationPart.TYPE?.toLowerCase().includes("app") ? "Appartement" : selectedVente.associationPart.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (selectedVente.associationPart.TYPE || "-")}
                  </Col>
                </Row> : null}
                {selectedVente.associationPart ? <Row>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faMap} />&nbsp;<strong>Position : </strong>{selectedVente.associationPart.POSITION || "-"}
                  </Col>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faRulerCombined} />&nbsp;<strong>Superficie : </strong>{selectedVente.associationPart.SUPERFICIE ? `${selectedVente.associationPart.SUPERFICIE}m²` : "-"}
                  </Col>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faCalendarAlt} />&nbsp;<strong>Date de vente : </strong>{selectedVente.associationPart.createdAt ? moment(selectedVente.associationPart.createdAt).format('DD/MM/YYYY') : "-"}
                  </Col>
                  <Col xs="12" sm="3">
                    <FontAwesomeIcon icon={faMoneyBill} />&nbsp;<strong>Prix de part : </strong>{(selectedVente.associationPart.PRIX_VENTE !== null && selectedVente.associationPart.PRIX_VENTE !== undefined) ? (selectedVente.associationPart.PRIX_VENTE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"}
                  </Col>
                </Row> : null}
              </Container> : <Container>
                <Row>
                  <p className="noTableData">Aucune vente sélectionnée</p>
                </Row>
              </Container>}
            {selectedVente ? <Container>
              <Row className="justify-content-center">
                {!!(/*auth?.user?.privileges?.includes(PRIVILEGE.DESISTEMENT) && */(!!enableDesistement || !!enableTransfert)) && <Col xs="12" lg="4" className="fullFlexCenter">
                  <CustomInput type="switch" id={`totalWithdraw_${panelNumber}`} name={`totalWithdrawSwitch_${panelNumber}`} label={selectedVente.associationPart ? "Libération de la part" : "Libération du bien"} checked={totalWithdraw} onChange={e => setTotalWithdraw(e.target.checked)} />
                </Col>}
                {!!(enableTransfert && panelNumber === 1) && <Col xs="12" lg="4" className="fullFlexCenter">
                  <CustomInput type="switch" id={`transferToNew_${panelNumber}`} name={`transferToNewSwitch_${panelNumber}`} label="Transférer vers nouvelle vente/part" checked={transferToNew} onChange={e => setTransferToNew(e.target.checked)} />
                </Col>}
                {!!(/*auth?.user?.privileges?.includes(PRIVILEGE.CHANGEMENT_BIEN) && */!!enableChangementBien) && <Col xs="12" lg="4" className="fullFlexCenter">
                  <CustomInput type="switch" id={`changeBien_${panelNumber}`} name={`changeBienSwitch_${panelNumber}`} label="Changement de bien" checked={changeBien} onChange={e => setChangeBien(e.target.checked)} />
                </Col>}
              </Row>
            </Container> : null}
            {selectedVente ? <div className="desistementChooseAnother">
              <span onClick={() => {setSelectedVente(undefined); search()}}><FontAwesomeIcon icon={faArrowLeft} />&nbsp;&nbsp;Choisir une autre vente</span>
            </div> : null}
            {(changeBien || transferToNew) && <div className="fullFlexCenter">
              <FontAwesomeIcon icon={faArrowDown} className="desistementChangeBienIcon" />
            </div>}
            {(changeBien || transferToNew) && <Container>
              <Row className="justify-content-between">
                <Col xs="12" md="12" lg={selectedBien ? "12" : "5"}><h2 className="title">{selectedBien ? "Le nouveau bien" : "Choisissez un bien"}</h2></Col>
                {!selectedBien && <Col xs="12" md="4" lg="2" className="societesSwitch">
                  <CustomInput type="switch" id="assiociation" name="associationSwitch" label={<div>Association&nbsp;{biensLoading && <FontAwesomeIcon icon={faSpinner} className={"spinner"} />}</div>} checked={isAssociationBien} onChange={changeIsAssociationBienHandle} disabled={biensLoading} />
                </Col>}
                {!selectedBien && <Col xs="12" md="3" lg="2" className="listPageFilterTitle">
                  <Label for="societesBiens">Projet : </Label>
                </Col>}
                {!selectedBien && <Col xs="12" md="5" lg="3" className="listPageFilterSelect">
                    <Select
                      id="societesBiens"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={societeBiensValue ? {label: societeBiensValue["LIBELE"], value: societeBiensValue} : null}
                      onChange={handleSocieteBiensChange}
                      placeholder={'Chercher par nom...'}
                      isClearable={false}
                      // isLoading={loadingS}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='LIBELE'
                      options={selectSocieteOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                </Col>}
              </Row>
            </Container>}
            {!!(changeBien || transferToNew) && (selectedBien ? <VBienCard selectedBien={selectedBien} setSelectedBien={setSelectedBien} isAssociation={isAssociationBien} association={selectedAssociation} setAssociation={setSelectedAssociation} remiseValue={remiseValue} setRemiseValue={setRemiseValue} remiseTotalValue={remiseTotalValue} setRemiseTotalValue={setRemiseTotalValue} prixAafficherValue={prixAafficherValue} setPrixAafficherValue={setPrixAafficherValue} prixAafficherTotalValue={prixAafficherTotalValue} setPrixAafficherTotalValue={setPrixAafficherTotalValue} displayTopDetails /> : biensLoading ? <Loading topSpace /> : <VBienTable linesData={biens} setSelectedBien={setSelectedBien} isAssociation={isAssociationBien} isFromDT />)}
            {/* </div> */}
            {/* <VBienContainer project={societeValue} isAssociation={isAssociation} info={info} setSelectedBien={setSelectedBien} association={association} setAssociation={setAssociation} remiseValue={remiseValue} setRemiseValue={setRemiseValue} remiseTotalValue={remiseTotalValue} setRemiseTotalValue={setRemiseTotalValue} prixAafficherValue={prixAafficherValue} setPrixAafficherValue={setPrixAafficherValue} prixAafficherTotalValue={prixAafficherTotalValue} setPrixAafficherTotalValue={setPrixAafficherTotalValue} /> */}
          </TabPane>
          {/* <TabPane tabId={constants.TAB_ASSOCIATION}>
            {selectedVente.TYPE_VENTE === "ASSOCIATION" ? venteLoading ? <Loading topSpace /> : (id !== undefined && id !== null && !isNaN(id) && id >= 0 && selectedVente?.bien) ?
              <Association associations={selectedVente.associations} etages={selectedVente.bien.ETAGE_ASS} associationPartInfo={associationPartInfo} setAssociationPartInfo={setAssociationPartInfo} /> : <Container>
              <Row>
                <p className="noTableData">Aucune vente sélectionnée</p>
              </Row>
            </Container> : null}
          </TabPane> */}
          <TabPane tabId={constants.TAB_CLIENT}>
            <ClientTable linesData={clientsTableData} setTableData={setClientsTableData} panelNumber={panelNumber} duplicateClient={duplicateClient} setDuplicateClient={setDuplicateClient} enableDesistement={enableDesistement} enableTransfert={enableTransfert} />
            {/* <ClientTable linesData={selectedVente?.contrat_clients?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || []} /> */}
          </TabPane>
          <TabPane tabId={constants.TAB_ENCAISSEMENT}>
            <EncaissementTable linesData={encaissementsTableData} setTableData={setEncaissementsTableData} panelNumber={panelNumber} enableDesistement={enableDesistement} enableTransfert={enableTransfert} />
            {/* <EncaissementTable linesData={selectedVente?.contrat_encaissements || []} /> */}
          </TabPane>
        </TabContent>
      </div>
      </div>}
      {!totalWithdraw && selectedVente && clientsTableData?.filter(e => !!e.desiste || !!e.desiste_p).length ? <>
        <Container className="addClientLineDiv">
          <Row className="justify-content-start mb-3">
            <Col xs="12" md="5">
              <FormGroup style={{marginBottom: '0.3rem'}}>
                <Label for="client">Associer d'autres clients au bien</Label>
                <AsyncSelect
                    id="client"
                    className="reactselect"
                    classNamePrefix="react-select"
                    key={asyncSelectKey}
                    cacheOptions
                    defaultOptions
                    value={selectedClient ? {label: selectedClient["NOM"], value: selectedClient} : null}
                    // loadOptions={(e, t) => loadOptions(e, t)}
                    loadOptions={promiseOptions}
                    onChange={handleClientSelectChange}
                    placeholder={'Chercher par nom ou par CIN...'}
                    isClearable={true}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                />
              </FormGroup>
            </Col>
            {!!auth?.user?.privileges?.includes(PRIVILEGE.ADD_CLIENT) && <Col xs="12" md="1" className="text-center orLabelCol">
              <Label className="addClientLineLabel">&nbsp;</Label>
              <Label className="orLabel">Ou</Label>
            </Col>}
            {!!auth?.user?.privileges?.includes(PRIVILEGE.ADD_CLIENT) && <Col xs="12" md="5">
              <Label className="addClientLineLabel">&nbsp;</Label>
              <Button
                className="btn btn-success addClientVenteBtn"
                onClick={() => setModalClient(true)}
                ><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Ajouter un nouveau client</Button>
            </Col>}
          </Row>
        </Container>
        <DesistementAddedClientTable linesData={tableAddedClientsLines} deleteTableClientC={deleteTableClientC} />
        <ClientAdd modal={modalClient} setModal={setModalClient} handleToggle={handleToggleClient} addTableClientCallback={addTableClientCallback} autoSelectUserId={auth?.user?.id} projet={{id: selectedVente?.IDPROJET, LIBELE: selectedVente?.PROJET}} />
      </> : null}
    </Container>
  );
};

const mapStateToProps = (state: IDesistementPanelReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {  })(DesistementPanelComponent);
